export enum MenuPointCallbackAction {
	LOGOUT = 'logout',
	HELP = 'help',
	NAVIGATION = 'navigation',
}
